import React from "react";
import { PageShell } from "@/components/Navbar";
import { MyBuyersPanel } from "@/components/MyBuyersPanel";

export default function MyBuyers() {
  return (
    <PageShell testid="my-buyers-page">
      <MyBuyersPanel />
    </PageShell>
  );
}
